<template>
	<div id="center">
		<div class="cc-header">工作日程</div>
		<dv-scroll-board :config="config" class="leavelist" />
	</div>
</template>

<script>
	var storage = window.localStorage;
	var orgId = storage.getItem("orgId");
	export default {
		data() {
			return {
				config: {}
			};
		},
		mounted() {
			this.initData();
			// 定时器刷新，1小时
			let _this = this;
			setInterval(() => {
				_this.initData(); // 修改数据date
			}, 1000 * 60 * 60);
		},
		methods: {
			initData() {
				let _this = this;
				this.$http.get("/dataView/headmaster/workProgram?orgId=" + orgId).then(res => {
					if (res.data.code === 200) {
						var result = [];
						for (let i = 0; i < res.data.result.length; i++) {
							var record = res.data.result[i];
							var workStatusHtml = '';
							if(record.workStatus == '未开始'){
								workStatusHtml = '<span class="yellow">&#8226; 未开始</span>';
							}else if(record.workStatus == '进行中'){
								workStatusHtml = '<span class="green">&#8226; 进行中</span>';
							}else{
								workStatusHtml = '<span class="red">&#8226; 已结束</span>';
							}
							result.push([record.workTheme, record.workDepict, record.cyUsers, workStatusHtml]);
						}
						if(result.length > 0){
							_this.config = {
								header: ['日程名称', '日程内容', '参与人', '进展状态'],
								data: result,
								headerBGC: '',
								oddRowBGC: 'none',
								evenRowBGC: 'none',
								headerHeight: 30,
								rowNum: 3, //表格行数
								waitTime: 2000,
								columnWidth: [150,300,300],
								align: ['left','left', 'left', 'right']
							};
						}else{
							_this.config = {
								data: [['<div class="noneData">暂无日程</div>']],
								evenRowBGC: 'none',
								rowNum: 1,
								align: ['center']
							};
						}
					}
				});
			}
		}
	};
</script>

<style lang="scss">
	#center {
		height: 100%;

		.leavelist {
			padding: 0.1rem 2%;
			width: 100%;
			height: 70%;
		}

		.leavelist .header {
			background: url("../../assets/img/hm_tblbg.png") center repeat-y;
			background-size: 100%;
			color: #00f0ff;
			font-size: 0.2rem;
			font-weight: bold;
		}

		.leavelist .row-item {
			background: url("../../assets/img/hm_tblbg.png") bottom no-repeat;
			background-size: 100%;
			color: #fff;
			font-size: 0.2rem;
		}
		.noback_list .row-item span {
			color: #ff5959
		}
	}
</style>
